import styled from 'styled-components'

import { COLORS } from '../commons/Colors'
import MainHeaderComponent from '../commons/components/MainHeaderComponent'
import { useUserContext } from '../context/UserContext'
import MainContent from './components/MainContent'

function HomeScreen(): JSX.Element {
    const { user } = useUserContext()
    const isDsmUser = user?.isDsm && user?.isUserGroupsSTC

    return (
        <PageContainer>
            <MainHeaderComponent />
            <PageTitle>
                {isDsmUser ? 'Time DSM-Firmenich' : 'Portal Administrativo'}
            </PageTitle>
            <MainContent isDsmUser={isDsmUser} />
        </PageContainer>
    )
}

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`

const PageTitle = styled.h1`
    color: ${COLORS.primaryOrange};
    font-size: 18px;
    font-family: Roboto;
    margin: auto;
    font-weight: normal;
    margin-top: 25px;
`

export default HomeScreen
